export const SetupEvents = function(modules: IDigitalIdentityHubModule[]) {
  window.janrainCaptureWidgetOnLoad = function() {
    /*--
            SHOW EVENTS:
            This function will log Janrain events in your browser's console. You must
            include janrain-utils.js to run this function. Comment this line to hide
            event logging.
                                                                                --*/
    window.DigitalIdentityHub.utilities.showEvents();

    /*--
            SHOW FLOW VERSION:
            This event handler shows the flow version in the specified element.
            This is primarily for our developers' convenience, but your developers
            may also find it useful.
                                                                                --*/

    janrain.events.onCaptureRenderStart.addHandler(function(result) {
      window.DigitalIdentityHub.utilities.showFlowVersion("flow-version", result);
    });

    janrain.events.onCaptureRenderComplete.addHandler(function() {
      const elements = [].slice.call(document.querySelectorAll(".capture_checkbox input"));

      elements.forEach(element => {
        element.parentNode.parentNode.insertBefore(element, element.parentNode);
      });
    });

    // Process Modules
    for (const m of modules) {
      try {
        m.ready();
      } catch (e) {
        console.log("Failed to load module (ready):", m.name, "error:", e);
      }
    }

    // This should be the last line in janrainCaptureWidgetOnLoad()
    janrain.capture.ui.start();
  };
};
